import { memo } from "react";
import { formatKm } from "services/api/fleet/tires/helpers";
import { TableSearch } from "ui/components/Table/TableSearch";
import { NoResults } from "ui/components/NoResults";
import { TIRE_SET_USAGE_COLUMNS } from "./consts";
import { TireSetUsageCardProps } from "./types";

/** Povijest korištenja seta guma: ciklusi montaže i skidanja s prijeđenim kilometrima. */
const TireSetUsageCard: React.FC<TireSetUsageCardProps> = ({ usages, totalKm }) => {
    return (
        <div className="m-[-1px]">
            <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200">
                <span className="text-sm font-bold text-slate-600">Povijest korištenja</span>
                <span className="text-sm text-slate-600">
                    Ukupno prijeđeno: <span className="font-semibold text-slate-900">{formatKm(totalKm)}</span>
                </span>
            </div>
            {!usages || usages.length === 0 ? (
                <NoResults message="Set još nije bio montiran uz evidenciju kilometraže." />
            ) : (
                <TableSearch
                    columns={TIRE_SET_USAGE_COLUMNS()}
                    data={usages}
                    selectableRows={false}
                    disablePagination={true}
                    isLoading={false}
                />
            )}
        </div>
    );
};

export default memo(TireSetUsageCard);
